import { Node } from '@cast/types';

import { CopyToClipboard } from 'components/clickable-actions';

import { Detail } from 'components/drawer';
import { NodeWithDependencies } from 'features/cluster/nodes/types';
import { getNodeRegion, isEdgeNode } from 'utils/node';
import { Box } from '@cast/design-system';

type NodeRegionDetailProps = {
  nodeDetails: Node | NodeWithDependencies | undefined;
};

export const NodeRegionDetail = ({ nodeDetails }: NodeRegionDetailProps) => {
  const region = getNodeRegion(nodeDetails);

  return (
    <Detail
      title="Region:"
      detail={
        <Box>
          {region}
          {isEdgeNode(nodeDetails) ? ' (Extended)' : ''}{' '}
          <CopyToClipboard
            text={region!}
            iconSize={16}
            sx={{ transform: 'translateY(3px)' }}
          />
        </Box>
      }
      testId="node-details-region"
    />
  );
};
